export default __webpack_public_path__ + "static/media/event-modal-header.2695ba2d.png";